import React, { useMemo, useState } from 'react';
import { FlexContainer, Heading, IconButton, UtilityChevronIcon } from '@placer-ui/components';
import { useAskFowReviewFormSchema } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/use-ask-for-review-flow-config';
import { ReviewOptions } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/steps/review-options';
import type {
    AskForReviewFormSectionValue,
    AskForReviewProps,
    EAskFowReviewFormSectionType,
} from './types';

export const AskForReview = ({ onSubmit, item }: AskForReviewProps) => {
    const { getFormsConfig } = useAskFowReviewFormSchema();

    const [selectedStep, setSelectedStep] = useState<EAskFowReviewFormSectionType | undefined>();

    const section = useMemo(() => {
        const formsConfig = getFormsConfig({
            status: item.status,
            entityId: item.entity_id,
            flag: item.flag_reasons?.[0],
        });
        return formsConfig.find((section) => section.type === selectedStep);
    }, [getFormsConfig, item.entity_id, item.flag_reasons, item.status, selectedStep]);

    const SectionForm = useMemo(() => {
        if (!section) return null;
        return section.Form;
    }, [section]);

    const handleBack = useMemo(
        () => (selectedStep ? () => setSelectedStep(undefined) : undefined),
        [selectedStep],
    );

    return (
        <FlexContainer width={344} height={372} flexDirection="column" gap={16}>
            <FlexContainer alignItems="center" justifyContent="space-between" height={'32px'}>
                <FlexContainer alignItems="center" gap={4}>
                    {!!handleBack && (
                        <IconButton
                            onClick={handleBack}
                            variant="ghost"
                            aria-label="back to previous step"
                            testId="ask-for-review-back-button"
                            Icon={<UtilityChevronIcon direction="right" />}
                        />
                    )}
                    <Heading testId="ask-for-review-title" variant="h6">
                        {section?.title ?? 'Ask For Review'}
                    </Heading>
                </FlexContainer>
            </FlexContainer>

            {!selectedStep && <ReviewOptions item={item} onSelectChange={setSelectedStep} />}
            {!!SectionForm && (
                <SectionForm
                    item={item}
                    onNextHandler={async (props) => {
                        onSubmit({
                            type: section!.type,
                            data: { ...(props as AskForReviewFormSectionValue) },
                            item,
                        });
                    }}
                />
            )}
        </FlexContainer>
    );
};
